<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 180 180"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>health-fitness-enthusiasts</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <circle
        id="path-1"
        cx="90"
        cy="90"
        r="90" />
    </defs>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-1186.000000, -34.000000)">
        <g
          id="health-fitness-enthusiasts"
          transform="translate(1186.000000, 34.000000)">
          <mask
            id="mask-2"
            fill="white">
            <use xlink:href="#path-1" />
          </mask>
          <g
            id="Oval"
            fill-rule="nonzero" />
          <g
            id="New_Symbol_77-26"
            mask="url(#mask-2)">
            <g
              id="Path"
              transform="translate(-8.000000, 0.000000)">
              <path
                d="M188.00001,90 C187.996558,53.2453739 165.644038,20.1858915 131.536436,6.49012295 C97.4288349,-7.2056456 58.4203147,1.21456088 32.9989976,27.7599783 C7.57768042,54.3053956 0.852158994,93.6415353 16.01,127.125 L179.99,127.125 C185.275032,115.462186 188.006044,102.804404 188.00001,90 L188.00001,90 Z"
                stroke="none"
                class="fill-extra-light"
                fill-rule="nonzero" />
              <line
                x1="10.2725"
                y1="127.17"
                x2="185.7725"
                y2="127.17"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </g>
          </g>
          <g
            id="Group"
            mask="url(#mask-2)">
            <g transform="translate(-5.750000, 22.500000)">
              <ellipse
                id="Oval"
                stroke="none"
                class="fill-extra-light"
                fill-rule="nonzero"
                cx="156.5"
                cy="137.4525"
                rx="33.75"
                ry="3.375" />
              <rect
                id="Rectangle"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero"
                x="100.25"
                y="1.17"
                width="93.375"
                height="103.5"
                rx="2.25" />
              <path
                id="Path"
                d="M188.4275,1.17 L102.5,1.17 C101.257359,1.17 100.25,2.17735931 100.25,3.42 L100.25,89.3475 L188.4275,1.17 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <rect
                id="Rectangle"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="100.25"
                y="1.17"
                width="93.375"
                height="103.5"
                rx="2.25" />
              <path
                id="Path"
                d="M200.3075,94.5 L149.75,94.5 C150.751178,95.4921654 151.607139,96.620822 152.2925,97.8525 L153.5525,100.1025 L200.3075,100.1025 C201.860801,100.1025 203.12,98.8433009 203.12,97.29 C203.12,95.7366991 201.860801,94.4775 200.3075,94.4775 L200.3075,94.5 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M145.6775,91.8 L144.98,100.17 L153.62,100.17 L152.36,97.92 C150.852665,95.2187861 148.561957,93.0379067 145.79,91.665 L145.6775,91.8 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <polygon
                id="Path"
                class="stroke fill-light"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                points="144.98 100.17 144.62 104.67 199.745 104.67 199.745 100.17" />
              <polygon
                id="Path"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero"
                points="147.995 64.17 142.37 64.17 135.62 104.67 144.62 104.67" />
              <polygon
                id="Path"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                points="147.995 64.17 142.37 64.17 135.62 104.67 144.62 104.67" />
              <path
                id="Path"
                d="M148.895,56.7 L143.27,50.6925 C141.447809,48.7681481 138.541713,48.3489997 136.25,49.68 L136.25,49.68 C135.313111,50.2288219 134.967562,51.4135619 135.4625,52.38 L140.615,63 C140.989982,63.7653722 141.765233,64.2531701 142.6175,64.26 L163.745,64.26 L163.745,59.5575 C163.685001,58.3589996 162.695,57.4184991 161.495,57.42 L150.5375,57.42 C149.913879,57.4179939 149.319062,57.1572521 148.895,56.7 Z"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M148.895,56.7 L143.27,50.6925 C141.447809,48.7681481 138.541713,48.3489997 136.25,49.68 L136.25,49.68 C135.313111,50.2288219 134.967562,51.4135619 135.4625,52.38 L140.615,63 C140.989982,63.7653722 141.765233,64.2531701 142.6175,64.26 L163.745,64.26 L163.745,59.5575 C163.685001,58.3589996 162.695,57.4184991 161.495,57.42 L150.5375,57.42 C149.913879,57.4179939 149.319062,57.1572521 148.895,56.7 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M170.495,64.17 L163.745,64.17 L163.745,59.67 L170.495,59.67 C171.737641,59.67 172.745,60.6773593 172.745,61.92 L172.745,61.92 C172.745,63.1626407 171.737641,64.17 170.495,64.17 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M136.25,136.3275 L136.25,111.5775 C136.25,110.334859 135.242641,109.3275 134,109.3275 L131.75,109.3275 C130.507359,109.3275 129.5,110.334859 129.5,111.5775 C129.5,115.83 129.5,129.735 129.5,136.3275 C129.5,137.570141 130.507359,138.5775 131.75,138.5775 L134,138.5775 C135.242641,138.5775 136.25,137.570141 136.25,136.3275 Z"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M136.25,136.3275 L136.25,111.5775 C136.25,110.334859 135.242641,109.3275 134,109.3275 L131.75,109.3275 C130.507359,109.3275 129.5,110.334859 129.5,111.5775 C129.5,115.83 129.5,129.735 129.5,136.3275 C129.5,137.570141 130.507359,138.5775 131.75,138.5775 L134,138.5775 C135.242641,138.5775 136.25,137.570141 136.25,136.3275 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M184.625,136.3275 L184.625,111.5775 C184.625,110.334859 183.617641,109.3275 182.375,109.3275 L180.125,109.3275 C178.882359,109.3275 177.875,110.334859 177.875,111.5775 C177.875,115.83 177.875,129.735 177.875,136.3275 C177.875,137.570141 178.882359,138.5775 180.125,138.5775 L182.375,138.5775 C183.617641,138.5775 184.625,137.570141 184.625,136.3275 Z"
                class="stroke fill-light"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <rect
                id="Rectangle"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="136.25"
                y="129.5775"
                width="41.625"
                height="4.5" />
              <circle
                id="Oval"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero"
                cx="147.5"
                cy="129.5775"
                r="5.625" />
              <circle
                id="Oval"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                cx="147.5"
                cy="129.5775"
                r="5.625" />
              <circle
                id="Oval"
                class="stroke fill-light"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                cx="165.5"
                cy="129.5775"
                r="4.5" />
              <path
                id="Path"
                d="M166.8725,111.5775 C166.240356,112.294284 165.330712,112.704912 164.375,112.704912 C163.419288,112.704912 162.509644,112.294284 161.8775,111.5775 L136.25,111.5775 L136.25,116.0775 L177.875,116.0775 L177.875,111.5775 L166.8725,111.5775 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <circle
                id="Oval"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero"
                cx="146.375"
                cy="111.5775"
                r="5.625" />
              <circle
                id="Oval"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                cx="146.375"
                cy="111.5775"
                r="5.625" />
              <path
                id="Path"
                d="M147.5,128.4525 C146.87868,128.4525 146.375,128.95618 146.375,129.5775 C146.375,130.19882 146.87868,130.7025 147.5,130.7025 C148.12132,130.7025 148.625,130.19882 148.625,129.5775 C148.625,128.95618 148.12132,128.4525 147.5,128.4525 Z"
                stroke="none"
                fill="#0066A4"
                fill-rule="nonzero" />
              <circle
                id="Oval"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero"
                cx="146.375"
                cy="111.5775"
                r="1.125" />
              <path
                id="Path"
                d="M146.375,110.4525 C145.75368,110.4525 145.25,110.95618 145.25,111.5775 C145.25,112.19882 145.75368,112.7025 146.375,112.7025 C146.99632,112.7025 147.5,112.19882 147.5,111.5775 C147.5,110.95618 146.99632,110.4525 146.375,110.4525 Z"
                stroke="none"
                fill="#0066A4"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M165.5,128.4525 C164.87868,128.4525 164.375,128.95618 164.375,129.5775 C164.375,130.19882 164.87868,130.7025 165.5,130.7025 C166.12132,130.7025 166.625,130.19882 166.625,129.5775 C166.625,128.95618 166.12132,128.4525 165.5,128.4525 Z"
                stroke="none"
                fill="#0066A4"
                fill-rule="nonzero" />
              <rect
                id="Rectangle"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero"
                transform="translate(65.375000, 142.335000) rotate(180.000000) translate(-65.375000, -142.335000) "
                x="44"
                y="126"
                width="42.75"
                height="32.67" />
              <path
                id="Path"
                d="M65.375,63 C56.1177729,63 47.2403538,66.6804887 40.6987275,73.2305558 C34.1571012,79.7806229 30.4880552,88.6627806 30.4999709,97.92 L30.4999709,104.67 L44,104.67 L44,133.92 L86.75,133.92 L86.75,104.67 L100.250029,104.67 L100.250029,97.92 C100.261945,88.6627806 96.5928988,79.7806229 90.0512725,73.2305558 C83.5096462,66.6804887 74.6322271,63 65.375,63 L65.375,63 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M130.625,96.2325 C130.625,97.7858009 129.365801,99.045 127.8125,99.045 C126.259199,99.045 125,97.7858009 125,96.2325 L125,92.8575 C125,91.3041991 126.259199,90.045 127.8125,90.045 C129.365801,90.045 130.625,91.3041991 130.625,92.8575 L130.625,96.2325 Z"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M125,101.8575 C125,103.410801 123.740801,104.67 122.1875,104.67 C120.634199,104.67 119.375,103.410801 119.375,101.8575 L119.375,87.2325 C119.375,85.6791991 120.634199,84.42 122.1875,84.42 C123.740801,84.42 125,85.6791991 125,87.2325 L125,101.8575 Z"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero" />
              <rect
                id="Rectangle"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                transform="translate(65.375000, 142.335000) rotate(180.000000) translate(-65.375000, -142.335000) "
                x="44"
                y="126"
                width="42.75"
                height="32.67" />
              <line
                id="Path"
                x1="65.375"
                y1="139.545"
                x2="65.375"
                y2="158.67"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <rect
                id="Rectangle"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero"
                transform="translate(83.937500, 146.250000) rotate(180.000000) translate(-83.937500, -146.250000) "
                x="81.125"
                y="133.8975"
                width="5.625"
                height="24.705" />
              <rect
                id="Rectangle"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                transform="translate(83.937500, 146.250000) rotate(180.000000) translate(-83.937500, -146.250000) "
                x="81.125"
                y="133.8975"
                width="5.625"
                height="24.705" />
              <rect
                id="Rectangle"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero"
                x="44"
                y="133.92"
                width="5.625"
                height="24.75" />
              <rect
                id="Rectangle"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="44"
                y="133.92"
                width="5.625"
                height="24.75" />
              <path
                id="Path"
                d="M44,92.25 C44,80.4449135 53.5699135,70.875 65.375,70.875 L65.375,70.875 C77.1800865,70.875 86.75,80.4449135 86.75,92.25 L86.75,133.92 L44,133.92 L44,92.25 Z"
                class="stroke fill-light"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <rect
                id="Rectangle"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero"
                transform="translate(65.375000, 94.545000) rotate(90.000000) translate(-65.375000, -94.545000) "
                x="62"
                y="46.17"
                width="6.75"
                height="96.75" />
              <rect
                id="Rectangle"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                transform="translate(65.375000, 94.545000) rotate(90.000000) translate(-65.375000, -94.545000) "
                x="62"
                y="46.17"
                width="6.75"
                height="96.75" />
              <path
                id="Path"
                d="M119.375,107.4825 C119.375,109.035801 118.115801,110.295 116.5625,110.295 C115.009199,110.295 113.75,109.035801 113.75,107.4825 L113.75,81.6075 C113.75,80.0541991 115.009199,78.795 116.5625,78.795 C118.115801,78.795 119.375,80.0541991 119.375,81.6075 L119.375,107.4825 Z"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M119.375,107.4825 C119.375,109.035801 118.115801,110.295 116.5625,110.295 C115.009199,110.295 113.75,109.035801 113.75,107.4825 L113.75,81.6075 C113.75,80.0541991 115.009199,78.795 116.5625,78.795 C118.115801,78.795 119.375,80.0541991 119.375,81.6075 L119.375,107.4825 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M125,101.8575 C125,103.410801 123.740801,104.67 122.1875,104.67 C120.634199,104.67 119.375,103.410801 119.375,101.8575 L119.375,87.2325 C119.375,85.6791991 120.634199,84.42 122.1875,84.42 C123.740801,84.42 125,85.6791991 125,87.2325 L125,101.8575 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M130.625,96.2325 C130.625,97.7858009 129.365801,99.045 127.8125,99.045 C126.259199,99.045 125,97.7858009 125,96.2325 L125,92.8575 C125,91.3041991 126.259199,90.045 127.8125,90.045 C129.365801,90.045 130.625,91.3041991 130.625,92.8575 L130.625,96.2325 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M5.75,101.8575 C5.75,103.410801 7.00919914,104.67 8.5625,104.67 C10.1158009,104.67 11.375,103.410801 11.375,101.8575 L11.375,87.2325 C11.375,85.6791991 10.1158009,84.42 8.5625,84.42 C7.00919914,84.42 5.75,85.6791991 5.75,87.2325 L5.75,101.8575 Z"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M11.375,107.4825 C11.375,109.035801 12.6341991,110.295 14.1875,110.295 C15.7408009,110.295 17,109.035801 17,107.4825 L17,81.6075 C17,80.0541991 15.7408009,78.795 14.1875,78.795 C12.6341991,78.795 11.375,80.0541991 11.375,81.6075 L11.375,107.4825 Z"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M11.375,107.4825 C11.375,109.035801 12.6341991,110.295 14.1875,110.295 C15.7408009,110.295 17,109.035801 17,107.4825 L17,81.6075 C17,80.0541991 15.7408009,78.795 14.1875,78.795 C12.6341991,78.795 11.375,80.0541991 11.375,81.6075 L11.375,107.4825 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M5.75,101.8575 C5.75,103.410801 7.00919914,104.67 8.5625,104.67 C10.1158009,104.67 11.375,103.410801 11.375,101.8575 L11.375,87.2325 C11.375,85.6791991 10.1158009,84.42 8.5625,84.42 C7.00919914,84.42 5.75,85.6791991 5.75,87.2325 L5.75,101.8575 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M65.375,63 C56.1177729,63 47.2403538,66.6804887 40.6987275,73.2305558 C34.1571012,79.7806229 30.4880552,88.6627806 30.4999709,97.92 L30.4999709,104.67 L44,104.67 L44,133.92 L86.75,133.92 L86.75,104.67 L100.250029,104.67 L100.250029,97.92 C100.261945,88.6627806 96.5928988,79.7806229 90.0512725,73.2305558 C83.5096462,66.6804887 74.6322271,63 65.375,63 L65.375,63 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M95.75,123.75 C100.720563,123.75 104.75,119.720563 104.75,114.75 L104.75,93.375 C104.75,90.2683983 102.231602,87.75 99.125,87.75 C96.0183983,87.75 93.5,90.2683983 93.5,93.375 L93.5,104.625 L86.75,104.625 L86.75,114.75 C86.75,119.720563 90.7794373,123.75 95.75,123.75 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="93.5"
                y1="97.92"
                x2="93.5"
                y2="110.295"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M35,123.75 C30.0294373,123.75 26,119.720563 26,114.75 L26,93.375 C26,90.2683983 28.5183983,87.75 31.625,87.75 C34.7316017,87.75 37.25,90.2683983 37.25,93.375 L37.25,104.625 L44,104.625 L44,114.75 C44,119.720563 39.9705627,123.75 35,123.75 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="37.25"
                y1="97.92"
                x2="37.25"
                y2="110.295"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M65.375,60.75 C62.6870354,60.744625 60.0211251,60.2647612 57.5,59.3325 L57.5,69.5475 C57.5476906,72.3414031 59.0600416,74.9047099 61.4825,76.2975 L61.4825,76.2975 C63.9053771,77.6754243 66.8761495,77.6699365 69.2939195,76.2830704 C71.7116894,74.8962043 73.2162322,72.3345896 73.25,69.5475 L73.25,59.355 C70.730267,60.2898547 68.0625367,60.7624241 65.375,60.75 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M65.375,60.75 C62.6870354,60.744625 60.0211251,60.2647612 57.5,59.3325 L57.5,69.5475 C57.5476906,72.3414031 59.0600416,74.9047099 61.4825,76.2975 L61.4825,76.2975 C63.9053771,77.6754243 66.8761495,77.6699365 69.2939195,76.2830704 C71.7116894,74.8962043 73.2162322,72.3345896 73.25,69.5475 L73.25,59.355 C70.730267,60.2898547 68.0625367,60.7624241 65.375,60.75 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M87.875,34.2675 L87.875,28.6425 C87.875,16.2160931 77.8014069,6.1425 65.375,6.1425 C52.9485931,6.1425 42.875,16.2160931 42.875,28.6425 L42.875,34.2675 C40.3897186,34.2675 38.375,36.2822186 38.375,38.7675 C38.375,41.2527814 40.3897186,43.2675 42.875,43.2675 L43.145,43.2675 C44.8570704,54.2191552 54.2903287,62.2922878 65.375,62.2922878 C76.4596713,62.2922878 85.8929296,54.2191552 87.605,43.2675 L87.875,43.2675 C90.3602814,43.2675 92.375,41.2527814 92.375,38.7675 C92.375,36.2822186 90.3602814,34.2675 87.875,34.2675 L87.875,34.2675 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M87.875,34.2675 L87.875,28.6425 C87.875,16.2160931 77.8014069,6.1425 65.375,6.1425 C52.9485931,6.1425 42.875,16.2160931 42.875,28.6425 L42.875,34.2675 C40.3897186,34.2675 38.375,36.2822186 38.375,38.7675 C38.375,41.2527814 40.3897186,43.2675 42.875,43.2675 L43.145,43.2675 C44.8570704,54.2191552 54.2903287,62.2922878 65.375,62.2922878 C76.4596713,62.2922878 85.8929296,54.2191552 87.605,43.2675 L87.875,43.2675 C90.3602814,43.2675 92.375,41.2527814 92.375,38.7675 C92.375,36.2822186 90.3602814,34.2675 87.875,34.2675 L87.875,34.2675 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <circle
                id="Oval"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero"
                cx="52.4375"
                cy="43.83"
                r="2.8125" />
              <circle
                id="Oval"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero"
                cx="78.3125"
                cy="43.83"
                r="2.8125" />
              <path
                id="Path"
                d="M58.6025,49.5 C62.387047,53.0886144 68.317953,53.0886144 72.1025,49.5"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M77.75,36.5175 C77.1743995,35.1639677 75.8458384,34.2852461 74.375,34.2852461 C72.9041616,34.2852461 71.5756005,35.1639677 71,36.5175"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M59.75,36.5175 C59.1743995,35.1639677 57.8458384,34.2852461 56.375,34.2852461 C54.9041616,34.2852461 53.5756005,35.1639677 53,36.5175"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M90.125,21.9825 L90.125,32.04 C90.125,33.2826407 89.1176407,34.29 87.875,34.29 C86.6323593,34.29 85.625,33.2826407 85.625,32.04 C85.6091899,26.3000478 82.227021,21.1034862 76.985,18.765 C74.4060228,20.0019712 71.6066456,20.7132884 68.75,20.8575 L68.5925,20.8575 C68.6442165,22.6036639 67.8685515,24.2717607 66.5,25.3575 C65.1669861,26.6635148 63.3125345,27.2927038 61.46,27.0675 C61.0886663,27.005144 60.7731491,26.7611518 60.6193859,26.4174458 C60.4656227,26.0737398 60.4940038,25.6758983 60.695,25.3575 C61.2439803,24.3124905 61.3097146,23.0799732 60.875,21.9825 C59.75,18.6975 55.25,18.6075 55.25,18.6075 L53.765,18.765 C48.522979,21.1034862 45.1408101,26.3000478 45.125,32.04 C45.125,33.2826407 44.1176407,34.29 42.875,34.29 C41.6323593,34.29 40.625,33.2826407 40.625,32.04 L40.625,21.9825 C40.6287375,17.7653206 42.4389248,13.7517832 45.5975,10.9575 C46.0117293,10.5868377 46.2891249,10.0875257 46.385,9.54 C47.3975,4.4775 55.52,0.54 65.375,0.54 C75.23,0.54 83.375,4.5 84.365,9.54 C84.4608751,10.0875257 84.7382707,10.5868377 85.1525,10.9575 C88.3110752,13.7517832 90.1212625,17.7653206 90.125,21.9825 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M68.5925,20.7675 C68.5925,18.9 67.445,17.3925 66.5,17.3925"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M90.125,21.9825 L90.125,32.04 C90.125,33.2826407 89.1176407,34.29 87.875,34.29 C86.6323593,34.29 85.625,33.2826407 85.625,32.04 C85.6091899,26.3000478 82.227021,21.1034862 76.985,18.765 C74.4060228,20.0019712 71.6066456,20.7132884 68.75,20.8575 L68.5925,20.8575 C68.6442165,22.6036639 67.8685515,24.2717607 66.5,25.3575 C65.1669861,26.6635148 63.3125345,27.2927038 61.46,27.0675 C61.0886663,27.005144 60.7731491,26.7611518 60.6193859,26.4174458 C60.4656227,26.0737398 60.4940038,25.6758983 60.695,25.3575 C61.2439803,24.3124905 61.3097146,23.0799732 60.875,21.9825 C59.75,18.6975 55.25,18.6075 55.25,18.6075 L53.765,18.765 C48.522979,21.1034862 45.1408101,26.3000478 45.125,32.04 C45.125,33.2826407 44.1176407,34.29 42.875,34.29 C41.6323593,34.29 40.625,33.2826407 40.625,32.04 L40.625,21.9825 C40.6287375,17.7653206 42.4389248,13.7517832 45.5975,10.9575 C46.0117293,10.5868377 46.2891249,10.0875257 46.385,9.54 C47.3975,4.4775 55.52,0.54 65.375,0.54 C75.23,0.54 83.375,4.5 84.365,9.54 C84.4608751,10.0875257 84.7382707,10.5868377 85.1525,10.9575 C88.3110752,13.7517832 90.1212625,17.7653206 90.125,21.9825 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
